// import React from "react";
// import {
//   Button,
//   Card,
//   CardHeader,
//   Card.Body,
//   CardTitle,
//   CardFooter,
//   Label,
//   FormGroup,
//   Form,
//   Alert,
//   Input,
//   InputGroupAddon,
//   InputGroupText,
//   InputGroup,
//   Container,
//   Col,
//   Row,
//   Progress,
//   Modal, ModalHeader, Modal.Body, Modal.Footer
// } from "reactstrap";
// import cookie from 'react-cookies'
// import axios from 'axios';
// import "components/custom.css";
// import currentStatus from "components/current-status.jpg";
// import completeStatus from "components/current-status-complete.jpg";
// import playingStatus from "components/current-status-playing.jpg";
// import completeRecord from "components/current-status-record-complete.jpg";
// import currentRecording from "components/current-status-recording.jpg";
// import img from "components/a.png";
// import API, { base, s3base } from "api.js";
// import IntroTest from "components/Question/Speaking/IntroTest.jsx";
// import { store, persistor } from 'store/index';
// import { setSub } from 'action/index.js';
// import NotificationAlert from "react-notification-alert";
// import { Navigate, NavLink } from "react-router-dom";
// import NoMicrophone from "views/NoMicrophone.jsx";
// import MicRecorder from 'mic-recorder-to-mp3';
// import Sound from 'react-sound';
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
// import MicWaveform from "components/Question/Speaking/MicWaveform";
// import OpenWithIcon from '@mui/icons-material/OpenWith';
// import NightsStayIcon from '@mui/icons-material/NightsStay';

// const Mp3Recorder = new MicRecorder({ bitRate: 128 });
// class ResourceCheck extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       questionData: [],
//       soundStatus: false,
//       isBlocked: false,
//       volume: 100,
//       soundPer: 0,
//       recordPer: 0,
//       isRecording: false,
//       recordingSoundStatus: false,
//       btnText: 'Playback',
//       mic: false,
//       headphone: false,
//       keyboard: false,
//       testDetail: false,
//       currDetail: false,
//       sequenceArr: [],
//       index: 0,
//       nextFlag: false,
//       startFlag: false,
//       intro: false,
//       speak_inst: false,
//       test_intro: false,
//       modal: false

//     };
//   }

//   componentDidMount() {

//     navigator.getUserMedia({ audio: true },
//       () => {
//         console.log('Permission Granted');
//         this.setState({ isBlocked: false });
//       },
//       () => {
//         console.log('Permission Denied');
//         this.setState({ isBlocked: true })
//       },
//     );
//     let arr;
//     if (this.props.cat === 1) {
//       arr = ['headphone', 'mic'];
//       this.setState({ sequenceArr: arr });
//     }
//     else if (this.props.cat === 2) {
//       arr = ['keyboard'];
//       this.setState({ sequenceArr: arr });
//     }
//     else if (this.props.cat === 3) {
//       arr = ['keyboard'];
//       this.setState({ sequenceArr: arr });
//     } else if (this.props.cat === 4) {
//       arr = ['headphone', 'keyboard'];
//       this.setState({ sequenceArr: arr });
//     }
//     else if (this.props.cat === 5 && this.props.pending == 1) {
//       arr = ['headphone', 'mic', 'keyboard'];
//       this.setState({ sequenceArr: arr });
//     } else if (this.props.cat === 5 && this.props.pending == 0) {
//       arr = ['headphone', 'mic', 'keyboard', 'test_intro', 'speak_inst', 'testDetail', 'currDetail', 'intro'];
//       this.setState({ sequenceArr: arr });
//     }
//     let flag = false;
//     if (arr[this.state.index] === 'keyboard') {
//       flag = true;
//     }
//     this.setState({ [arr[this.state.index]]: true, nextFlag: flag });

//   }

//   // onSound = () =>{
//   //   this.setState({soundStatus:true});
//   // }

//   // offSound = () =>{
//   //   this.setState({soundStatus:false,nextFlag:true});
//   // }
//   onSound = () => {
//     if (!this.state.soundStatus) {
//       this.setState({ soundStatus: true });
//     }
//   };

//   offSound = () => {
//     if (this.state.soundStatus) {
//       this.setState({ soundStatus: false, nextFlag: true });
//     }
//   };


//   handleSongFinishedPlaying = () => {
//     this.setState({ soundStatus: false, nextFlag: true });
//   }

//   recordingFinishedPlaying = () => {
//     this.setState({ recordingSoundStatus: false });
//   }

//   changeRange = (e) => {
//     this.setState({ volume: e.target.value });
//   }

//   handleSongPlaying = (obj) => {
//     this.setState({ soundPer: obj.position * 100 / obj.duration });
//   }

//   handleRecordPlaying = (obj) => {
//     this.setState({ recordPer: obj.position * 100 / obj.duration });
//   }

//   nextButton = () => {
//     if (this.state.index < (this.state.sequenceArr.length - 1)) {
//       let arr = this.state.sequenceArr;
//       let oldIndex = this.state.index;
//       let newIndex = this.state.index + 1;
//       let flag = false;
//       let mod = false;
//       if ([arr[newIndex]] == 'keyboard' || [arr[newIndex]] == 'testDetail' || [arr[newIndex]] == 'currDetail' || [arr[newIndex]] == 'test_intro' || [arr[newIndex]] == 'speak_inst' || [arr[newIndex]] == 'intro') {
//         flag = true;
//       }
//       this.setState({ [arr[newIndex]]: true, [arr[oldIndex]]: false, index: newIndex, nextFlag: flag, modal: mod });
//     } else {
//       if (this.state.sequenceArr[this.state.index] == 'intro') {
//         this.setState({ modal: true });
//       } else {
//         this.setState({ startFlag: true });
//       }

//     }
//   }

//   playRecording = () => {
//     if (this.state.recordingSoundStatus) {
//       this.setState({ recordingSoundStatus: false, btnText: 'Playback', nextFlag: true });
//     } else {
//       this.setState({ recordingSoundStatus: true, btnText: 'Stop Playback' });
//     }

//   }

//   nextStep = () => {
//     if (this.state.index < (this.state.sequenceArr.length - 1)) {
//       this.setState({ nextFlag: true });
//     } else {
//       this.setState({ startFlag: true });
//     }
//   }

//   startRecording = () => {
//     if (this.state.isBlocked) {
//       alert("Please attach your microphone")
//     } else {
//       console.log("recording button");

//       Mp3Recorder
//         .start()
//         .then(() => {
//           this.setState({ isRecording: true, blobURL: '' });
//         }).catch((e) => console.error(e));
//     }
//   }

//   toggleYes = () => {
//     this.setState({ modal: false, startFlag: true }, function () {
//       this.props.showTest();
//     });

//   }

//   toggle = () => {
//     this.setState({ modal: false });
//   }

//   stopRecording = () => {
//     if (!this.state.isBlocked) {
//       Mp3Recorder
//         .stop()
//         .getMp3()
//         .then(([buffer, blob]) => {
//           const blobURL = URL.createObjectURL(blob)
//           this.setState({ blobURL, isRecording: false });
//         }).catch((e) => console.log(e));
//     }
//   }

//   render() {
//     if (this.state.sequenceArr[this.state.index] != 'intro' && this.state.index == (this.state.sequenceArr.length - 1) && !this.state.startFlag) {
//       this.setState({ startFlag: true });
//     }
//     // console.log(this.props.data)
//     console.log("this.state.headphone===",this.state.headphone);

//     return (
//       <>
//         {this.state.modal &&
//           <Modal isOpen={this.state.modal} size="sm">
//             <Modal.Body>
//               <div>Do you want to go to next Question?</div>
//             </Modal.Body>
//             <Modal.Footer>
//               <Button color="secondary" className="modalCloseBtn" onClick={this.toggleYes}>Yes</Button>
//               <Button color="secondary" className="modalCloseBtn" onClick={this.toggle}>No</Button>
//             </Modal.Footer>
//           </Modal>
//         }
// {/* id="deviceTestPage" */}
//         <div className="content questionsArea deviceTestPage old-design m-0 p-0">
//           <Row style={{width: "100vw"}}>
//             <Col xs={12} className="p-0">
//               <div className="border-top-0 bg-transparent">
//                 {/* Equivalent to CardHeader */}
//                 <div className="p-0">
//                   <div
//                     className="d-flex align-items-end flex-column gap-1 rounded-2"
//                     style={{ backgroundColor: "white" }}
//                   >
//                     {/* Header Row (Gray Bar with Title) */}
//                     <div
//                       className="d-flex justify-content-between align-items-center w-100"
//                       style={{
//                         backgroundColor: "#BFBABB",
//                         height: "40px",
//                       }}
//                     >
//                       <div style={{ width: "fit-content", padding: "20px" }}>
//                         <h4 className="m-0">Mock Test</h4>
//                       </div>
//                     </div>

//                     {/* Toolbar Row (Blue Bar with Icons) */}
//                     <div
//                       className="d-flex justify-content-end align-items-center px-4 w-100"
//                       style={{
//                         backgroundColor: "#0081A4",
//                         minHeight: "40px",
//                       }}
//                     >
//                       <div className="d-flex justify-content-end gap-3">
//                         <OpenWithIcon sx={{ color: "white" }} />
//                         <NightsStayIcon sx={{ color: "white" }} />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </Col>
//             <Col xs={12} style={{width: "100vw"}} className="p-0">
//               <Card className="border-0" >
//                 <Card.Body>
//                   {this.state.headphone &&
//                     <div className="col-xs-12 successContent">
//                       <div className="row">
//                         <div className="col-sm-8">
//                           <h4 className="mt-0">Headset check</h4>
//                           <h6>This is an opportunity to check that your headset is working correctly</h6>
//                           <ol>
//                             <li>Put your headset on and adjust it so that if it's comfortably over your ears</li>
//                             <li>When you are ready. cilck on the play button. You hear a short recording</li>
//                             <li>If you do not hear anything in your headphones while the status reads Playing. Raise your hard to get the alteration of the Test Administator</li>
//                             <li>During the test you will not have Play and Stop buttons. The audio recording will start playing automatically</li>
//                             <li>Please do not remove your headset. You should wear it throughtout the test</li>
//                           </ol>
//                           <div className="currentStatus">
//                             <p>Status: Click Play to begin<br></br>Volume</p>
//                             <Input placeholder="Volume" type="range" min="0" defaultValue={this.state.volume} step="1" onInput={(e) => this.changeRange(e)} max="100" />
//                             <br></br>
//                             <Progress color="info" value={this.state.soundPer} />
//                             <div className='stop-btn'>
//                               <Button color="success" disabled={this.state.soundStatus} onClick={this.onSound} className="p-5px" size="xs">Play</Button>
//                               <Button color="success" disabled={!this.state.soundStatus} onClick={this.offSound} className="p-5px" size="xs">Stop</Button>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="col-sm-4">
//                           <div className="testingImgOuter">
//                             <img src="https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE2OJVN?ver=7462&q=90&m=6&h=431&w=767&b=%23FFFFFFFF&l=f&f=jpg&o=t&aim=true" alt="headset" />
//                           </div>
//                         </div>
//                       </div>
//                       <div className="note w-100 d-none">
//                         <ul>
//                           <li>During the test you will not have Play and Stop buttons. The audio recording will start playing automatically</li>
//                           <li>Please do not remove your headset. You should wear it throughtout the test</li>
//                         </ul>
//                       </div>
//                     </div>
//                   }

//                   {this.state.speak_inst &&
//                     <div className="col-xs-12 successContent">
//                       <div className="row w-100">
//                         <div className="col-lg-12">
//                           <h4 className="mt-0">Speaking Instructions</h4>
//                           <h6>Some questions require you to first listen to an audio clip and then record your answer by speaking clearly into the microphone.</h6>
//                           <div className="row speakingStatus mb-5 mt-4">
//                             <div className="col-sm-4">
//                               <p><b>Listening: </b>The Current Status shows how long you have until the audio clip starts.</p>
//                               <img src={currentStatus} />
//                             </div>
//                             <div className="col-sm-6 pl-5">
//                               <p>A blue bar shows the progress of the audio clip. When it reaches the right hand side the audio, clip will stop playing.</p>
//                               <div className="row doubleImges">
//                                 <div className="col-sm-6">
//                                   <img src={completeStatus} />
//                                 </div>
//                                 <div className="col-sm-6">
//                                   <img src={playingStatus} />
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="row speakingStatus">
//                             <div className="col-sm-4">
//                               <p><b>Speaking: </b>The Current Status shows how long you have until the microphone opens. Start speaking when the status changes to recording.</p>
//                               <img src={currentStatus} />
//                             </div>
//                             <div className="col-sm-6 pl-5">
//                               <p>You must finish before the progress bar reaches the right hand side. If you remain silent for longer than 3 seconds, the recording will stop. You will not be able to re-record.</p>
//                               <div className="row doubleImges">
//                                 <div className="col-sm-6">
//                                   <img src={completeRecord} />
//                                 </div>
//                                 <div className="col-sm-6">
//                                   <img src={currentRecording} />
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   }

//                   {this.state.test_intro &&
//                     <div className="col-xs-12 successContent">
//                       <div className="row w-100">
//                         <div className="col-lg-12">
//                           <h4 className="mt-0">Test Introduction</h4>
//                           <h6>This test measures the Reading, Writing, Listening and Speaking skills in English that you will need in an academic setting.</h6>
//                           <ol>
//                             <li>The test is divided into 3 parts. Each part may contain a number of sections. The sections are individually timed. The timer will be shown in the top right corner of your screen. The number of items in the section will also be displayed.
//                               <div className="timeBlock">
//                                 <div className="timeBlockInr text-right">
//                                   <p><i className="fa fa-clock-o" aria-hidden="true"></i> Time Remaining : 00:32:56</p>
//                                   <p>Item 22 of 39</p>
//                                 </div>
//                               </div>
//                             </li>
//                             <li>At the beginning of each part you will receive instructions. These will provide details on what to expect in that part of the test.</li>
//                             <li>By clicking on the Next (N) button at the bottom of each screen you confirm your answer and move to the next question. If you click on Next (N) you will not be able to return to the previous question. You will not be able to revisit any question at the end of the test.</li>
//                             {this.props.data.break === 0 ? (
//                               <li>You will be offered a break of up to 10 minutes before Listening part. The break is optional.</li>
//                             ) : ''}
//                             <li>This test makes use of different varieties of English, for example, British, American, Australian. You can answer in the standard English variety of your choice.</li>
//                             <li>During the test, do not click on any browser buttons (front, back, or reload). If you want to leave in between any sections, just use Save & Exit button. And if you want to leave after finshing a section, just use Save and Exit button.</li>
//                           </ol>
//                         </div>
//                       </div>
//                     </div>
//                   }

//                   {this.state.mic &&
//                     <div className="col-xs-12 successContent">
//                       <div className="row w-100">
//                         <div className="col-sm-8">
//                           <h4 className="mt-0">Microphone Check</h4>
//                           <h6>This is an opportunity to check that your microphone is working correctly</h6>
//                           <ol>
//                             <li>Make sure your headset is on and the microphone is in the downward position near your mouth.</li>
//                             <li>When you are ready, click on the Record button and say "Testing, testing, one, two, three" into the microphone</li>
//                             <li>After you have spoken, cilck on the Stop button. Your recording is now complete</li>
//                             <li>Now click on the Playback button. You should clearly hear yourself speaking</li>
//                             <li>If you can not hear your voice clearly. please raise your hand to get the atteration of the Test Administrator</li>  
//                             <li>During the test, you will not have Record, Playback, and Stop buttons. The voice recording will start automatically.</li>
//                           </ol>
//                           <div className="currentStatus">
//                             <p>Status: Click record to begin</p>
//                             <Progress color="info" value={this.state.recordPer} />
//                             {/* <MicWaveform progressValue={this.state.soundPer} /> */}

//                             <div className='stop-btn'>
//                               <Button color="success" disabled={this.state.isRecording} className="p-5px" onClick={this.startRecording} size="xs">Record</Button>
//                               <Button color="success" onClick={this.playRecording} className="p-5px" size="xs">{this.state.btnText}</Button>
//                               <Button color="success" disabled={!this.state.isRecording} onClick={this.stopRecording} className="p-5px" size="xs">Stop</Button>
//                             </div>
//                             {this.state.isRecording &&
//                               <div>Recording is started, please click on stop button for stop recording</div>
//                             }
//                           </div>
//                           <div className="note d-none">
//                             <ul>
//                               <li>During the test, you will not have Record, Playback, and Stop buttons. The voice recording will start automatically.</li>
//                             </ul>
//                           </div>
//                         </div>
//                         <div className="col-sm-4">
//                           <div className="testingImgOuter">
//                             <img src="https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE2OJVN?ver=7462&q=90&m=6&h=431&w=767&b=%23FFFFFFFF&l=f&f=jpg&o=t&aim=true" alt="headset" />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   }

//                   {this.state.keyboard &&
//                     <div className="col-xs-12 successContent">
//                       <div className="col-lg-12 keyboard-check">
//                         <h4 className="mt-0">Keyboard Check</h4>
//                         <h6>This is an opportunity to check that you have the correct keyboard.</h6>
//                         <div className="col-xs-12">
//                           <ol>
//                             <li>Look at the top row of letters on the keyboard.</li>
//                             <li>The letters should appear in this order Q W E R T Y.</li>
//                             <li>If you do not have a QWERTY keyboard, raise your hand to get the attention of the Test Administrator</li>
//                           </ol>
//                           <div className="keyboardImg">
//                             <img src={img} alt="keyboard" />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   }

//                   {this.state.testDetail &&
//                     <div className="col-xs-12 successContent">
//                       <div className="col-lg-12">
//                         <h4 className="mt-0">Welcome {store.getState().user.first_name} {store.getState().user.last_name}</h4>
//                         <div className="col-xs-12">
//                           <table className="table table-bordered">
//                             <tbody>
//                               <tr>
//                                 <th>Part</th>
//                                 <th>Content</th>
//                                 <th>Time Allowed</th>
//                               </tr>
//                               <tr>
//                                 <td>1</td>
//                                 <td>Speaking & writing</td>
//                                 <td>{this.props.data.time[0]} minutes</td>
//                               </tr>
//                               <tr>
//                                 <td>2</td>
//                                 <td>Reading</td>
//                                 <td>{this.props.data.time[1]} minutes</td>
//                               </tr>
//                               {this.props.data.break === 0 ? (
//                                 <tr>
//                                   <td colSpan={2}>Optional scheduled break</td>
//                                   <td>10 minutes</td>
//                                 </tr>) : ''
//                               }
//                               <tr>
//                                 <td>3</td>
//                                 <td>Listening</td>
//                                 <td>{this.props.data.time[2]} minutes</td>
//                               </tr>
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                     </div>
//                   }

//                   {this.state.intro &&
//                     <IntroTest />
//                   }

//                   {this.state.currDetail &&
//                     <div className="col-xs-12 successContent">
//                       <div className="col-lg-12">
//                         <h4 className="mt-0">Welcome {store.getState().user.first_name} {store.getState().user.last_name}</h4>
//                         <div className="col-xs-12">
//                           <table className="table table-bordered">
//                             <tbody>
//                               <tr>
//                                 <th>Section</th>
//                                 <th>No of Question</th>
//                                 <th>Time Allowed</th>
//                               </tr>
//                               <tr>
//                                 <td>Speaking & writing</td>
//                                 <td>{this.props.data.full[0].length}</td>
//                                 <td>{this.props.data.time[0]} minutes</td>
//                               </tr>
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                     </div>
//                   }

//                   {this.state.soundStatus &&
//                     <Sound
//                       url={s3base + "/ptedata/ptemedia/AUD (2)_1539694341.mp3"}
//                       playStatus={Sound.status.PLAYING}
//                       onFinishedPlaying={this.handleSongFinishedPlaying}
//                       onPlaying={this.handleSongPlaying}
//                       volume={this.state.volume}
//                       onError={(err) => {
//                         if (err.name !== "AbortError") console.error(err);
//                       }}
//                     />
//                   }

//                   {this.state.blobURL && this.state.recordingSoundStatus &&
//                     <Sound
//                       url={this.state.blobURL}
//                       playStatus={Sound.status.PLAYING}
//                       onPlaying={this.handleRecordPlaying}

//                       onFinishedPlaying={this.playRecording}
//                     />
//                   }
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col xs={12}>
//               <div className="bottom-0 bottomBtns position-fixed w-100">
//                 <Row>
//                   <Col xs={9}></Col>

//                   <Col xs={3} className="d-flex justify-content-end">
//                     {!this.state.startFlag &&
//                       <Button color="primary" disabled={!this.state.nextFlag} onClick={this.nextButton} size="xs" className="mock-btn">NEXT</Button>
//                     }
//                     {this.state.startFlag &&
//                       <Button color="primary" onClick={this.props.showTest} size="xs" className="mock-btn">Next</Button>
//                     }
//                   </Col>
//                 </Row>
//               </div>
//             </Col>
//           </Row>
//         </div>


//         {/*<div className="questionsArea deviceTestPage p-0 w-100">
//           <DashboardHeader title="Headset check" />
//           <Row className="outer-wrapper w-auto">
//             <Col xs={12} className="p-0">
//               <Card className="bg-transparent shadow-none">
//                 <Card.Body className="p-0">
//                   {this.state.headphone && <div className="col-xs-12 successContent p-0">
//                     <div className="row p-0">
//                       <div className="col-sm-4 p-0">
//                         <div className="test-intro-card">
//                           <h4 className="test-intro-title">Instruction</h4>
//                           <div className="testingImgOuter">
//                             <img src="https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE2OJVN?ver=7462&q=90&m=6&h=431&w=767&b=%23FFFFFFFF&l=f&f=jpg&o=t&aim=true" alt="headset" />
//                           </div>
//                             <ol className="test-intro-content">
//                               <li>This is an opportunity to check that your headset is working correctly</li>
//                               <li>Put your headset on and adjust it so that if it's comfortably over your ears</li>
//                               <li>When you are ready. cilck on the play button. You hear a short recording</li>
//                               <li>If you do not hear anything in your headphones while the status reads Playing. Raise your hard to get the alteration of the Test Administator</li>
//                             </ol>                  
//                         </div>
//                       </div>
//                       <div className="col-sm-8 pr-0">
//                           <div className="d-flex test-audio-content card-wrapper">
//                             <ul className="note">
//                               <li>During the test you will not have Play and Stop buttons.</li>
//                               <li>The audio recording will start playing automatically</li>
//                               <li>Please do not remove your headset. You should wear it throughtout the test</li>
//                             </ul>
//                               <div className="currentStatus">
//                                   <p className="currentStatus-title">Status: <span>Click Play to begin</span> Volume</p>
//                                   <div className="recorded-audio-wrapper">
//                                     <audio className="mt-0" controls
//                                         src="" type="audio/mpeg">
//                                       </audio>
//                                   </div>
//                                   <br />
//                                   <Input placeholder="Volume" type="range" min="0" defaultValue={this.state.volume} step="1" onInput={(e) => this.changeRange(e)} max="100"  />
//                                   <br></br>
//                                   <Progress color="info" value={this.state.soundPer} />
//                                   <div className='stop-btn'>
//                                     <Button color="success" disabled={this.state.soundStatus} onClick={this.onSound} className="p-5px" size="xs">Play</Button>
//                                     <Button color="success" disabled={!this.state.soundStatus} onClick={this.offSound} className="p-5px" size="xs">Stop</Button>
//                                   </div>
//                               </div>
//                           </div>
//                       </div>
//                     </div>
//                 </div>}
//                 {this.state.speak_inst && <div className="col-xs-12 successContent p-0">
//                   <div className="row w-100">
//                     <div className="col-lg-12 test-intro-card">
//                         <h4 className="test-intro-title">Speaking Instructions</h4>
//                         <h6 className="test-intro-title">Some questions require you to first listen to an audio clip and then record your answer by speaking clearly into the microphone.</h6>
//                         <div className="row speakingStatus mb-4 mt-4 test-intro-content">
//                           <div className="col-sm-6">
//                             <p><b>Listening: </b>The Current Status shows how long you have until the audio clip starts.</p>
//                             <img src={currentStatus} />
//                           </div>
//                           <div className="col-sm-6">
//                             <p>A blue bar shows the progress of the audio clip. When it reaches the right hand side the audio, clip will stop playing.</p>
//                             <div className="row doubleImges">
//                               <div className="col-sm-6"><img src={completeStatus} /></div>
//                               <div className="col-sm-6"><img src={playingStatus} /></div>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row speakingStatus test-intro-content">
//                           <div className="col-sm-6">
//                             <p><b>Speaking: </b>The Current Status shows how long you have until the microphone opens. Start speaking when the status changes to recording.</p>
//                             <img src={currentStatus} />
//                           </div>
//                           <div className="col-sm-6">
//                             <p>You must finish before the progress bar reaches the right hand side. If you remain silent for longer than 3 seconds, the recording will stop. You will not be able to re-record.</p>
//                             <div className="row doubleImges">
//                               <div className="col-sm-6"><img src={completeRecord} /></div>
//                               <div className="col-sm-6"><img src={currentRecording} /></div>
//                             </div>
//                           </div>
//                         </div>
//                     </div>
//                   </div>
//                 </div>}
//                 {this.state.test_intro && <div className="col-xs-12 successContent p-0">
//                 <div className="row w-100">
//                   <div className="col-sm-12 p-0">
//                     <div className="test-intro-card">
//                       <h4 className="test-intro-title">Test Introduction</h4>
//                       <ol className="test-intro-content">
//                         <li>This test measures the Reading, Writing, Listening and Speaking skills in English that you will need in an academic setting.</li>
//                         <li>The test is divided into 3 parts. Each part may contain a number of sections. The sections are individually timed. The timer will be shown in the top right corner of your screen. The number of items in the section will also be displayed.
//                           <div className="timeBlock">
//                             <div className="timeBlockInr text-right card-wrapper border-none">
//                               <p><i className="fa fa-clock-o" aria-hidden="true"></i> Time Remaining : 00:32:56</p>
//                               <p>Item 22 of 39</p>
//                             </div>
//                           </div>
//                         </li>
//                         <li>At the beginning of each part you will receive instructions. These will provide details on what to expect in that part of the test.</li>
//                         <li>By clicking on the Next (N) button at the bottom of each screen you confirm your answer and move to the next question. If you click on Next (N) you will not be able to return to the previous question. You will not be able to revisit any question at the end of the test.</li>
//                         {this.props.data.break === 0 ?<li>You will be offered a break of up to 10 minutes before Listening part. The break is optional.</li> : '' }
//                         <li>This test makes use of different varieties of English, for example, British, American, Australian. You can answer in the standard English variety of your choice.</li>
//                         <li>During the test, do not click on any browser buttons (front, back, or reload). If you want to leave in between any sections, just use Save & Exit button. And if you want to leave after finshing a section, just use Save and Exit button.</li>
//                       </ol>
//                     </div>
//                   </div>
//                 </div>
//                 </div>}
//                 {this.state.mic && <div className="col-xs-12 successContent p-0">
//                     <div className="row w-100">
//                       <div className="col-sm-4">
//                       <div className="test-intro-card">
//                         <h4 className="test-intro-title">Microphone Check</h4>
//                         <div className="testingImgOuter">
//                           <img src="https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE2OJVN?ver=7462&q=90&m=6&h=431&w=767&b=%23FFFFFFFF&l=f&f=jpg&o=t&aim=true" alt="headset" />
//                         </div>
//                         <ol className="test-intro-content">
//                           <li>This is an opportunity to check that your microphone is working correctly</li>
//                           <li>Make sure your headset is on and the microphone is in the downward position near your mouth.</li>
//                           <li>When you are ready, click on the Record button and say "Testing, testing, one, two, three" into the microphone</li>
//                           <li>After you have spoken, cilck on the Stop button. Your recording is now complete</li>
//                           <li>Now click on the Playback button. You should clearly hear yourself speaking</li>
//                           <li>If you can not hear your voice clearly. please raise your hand to get the atteration of the Test Administrator</li>
//                         </ol>
//                       </div>
//                       </div>
//                       <div className="col-sm-8">
//                       <div className="d-flex test-audio-content card-wrapper">
//                             <ul className="note">
//                               <li>During the test, you will not have Record, Playback, and Stop buttons. The voice recording will start automatically.</li>
//                             </ul>
//                             <div className="currentStatus">
//                             <p className="currentStatus-title">Status: <span>Click record to begin</span></p>
//                             <div className="recorded-audio-wrapper">
//                               <audio className="mt-0" controls
//                                   src="" type="audio/mpeg">
//                               </audio>
//                             </div>
//                             <br />
//                               <Progress color="info" value={this.state.recordPer} />
//                               <div className='stop-btn'>
//                                 <Button color="success" disabled={this.state.isRecording} className="p-5px" onClick={this.startRecording} size="xs">Record</Button>
//                                 <Button color="success" onClick={this.playRecording} className="p-5px" size="xs">{this.state.btnText}</Button>
//                                 <Button color="success" disabled={!this.state.isRecording} onClick={this.stopRecording} className="p-5px" size="xs">Stop</Button>
//                               </div>
//                               {this.state.isRecording && <div className="alert-message">Recording is started, please click on stop button for stop recording</div>}
//                             </div>                        
//                       </div>
//                       </div>
//                       </div>
//                   </div>}
//                 { this.state.keyboard && <div className="successContent p-0">       
//                     <div className="row w-100">       
//                       <div className="col-lg-12 p-0">
//                           <div className="test-intro-card">
//                           <h4 className="test-intro-title">Keyboard Check</h4>
//                               <div className="keyboardImg mb-4">
//                                 <img src={img} alt="keyboard" />
//                               </div>
//                               <ol className="test-intro-content">
//                                 <li>This is an opportunity to check that you have the correct keyboard.</li>
//                                 <li>Look at the top row of letters on the keyboard.</li>
//                                 <li>The letters should appear in this order Q W E R T Y.</li>
//                                 <li>If you do not have a QWERTY keyboard, raise your hand to get the attention of the Test Administrator</li>
//                               </ol>
//                           </div>
//                       </div>
//                     </div>
//                 </div>}
//                 {this.state.testDetail && <div className="col-xs-12 successContent card-wrapper">
//                   <div className="col-lg-12">
//                     <h4 className="test-user-name">Welcome {store.getState().user.first_name} {store.getState().user.last_name}</h4>
//                     <div className="table-wrapper">
//                       <table className="table">                   
//                           <thead>
//                             <tr>
//                               <th className="table-counting">Part</th>
//                               <th>Content</th>
//                               <th>Time Allowed</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                           <tr>
//                             <td>1</td>
//                             <td>Speaking & writing</td>
//                             <td>{this.props.data.time[0]} minutes</td>
//                           </tr>
//                           <tr>
//                             <td>2</td>
//                             <td>Reading</td>
//                               <td>{this.props.data.time[1]} minutes</td>
//                           </tr>
//                           {this.props.data.break === 0 ? <tr>
//                             <td colSpan={2}>Optional scheduled break</td>
//                               <td>10 minutes</td>
//                           </tr> : ''}
//                           <tr>
//                             <td>3</td>
//                             <td>Listening</td>
//                             <td>{this.props.data.time[2]} minutes</td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>
//                     </div>
//                 </div>}
//                 {this.state.intro && <IntroTest />}
//                 {this.state.currDetail && <div className="col-xs-12 successContent card-wrapper">
//                   <div className="col-lg-12">
//                     <h4 className="test-user-name">Welcome {store.getState().user.first_name} {store.getState().user.last_name}</h4>
//                     <div className="table-wrapper speaking-writing-table">
//                       <table className="table">                  
//                             <thead>
//                               <tr>
//                                 <th>Section</th>
//                                 <th>No of Question</th>
//                                 <th>Time Allowed</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                             <tr>
//                               <td className="text-left">Speaking & writing</td>
//                               <td>{this.props.data.full[0].length}</td>
//                               <td>{this.props.data.time[0]} minutes</td>
//                             </tr>
//                         </tbody>
//                       </table>
//                     </div>
//                     </div>
//                 </div>}
//                 {this.state.soundStatus && <Sound
//                   url={s3base + "/ptedata/ptemedia/AUD (2)_1539694341.mp3"}
//                   playStatus={Sound.status.PLAYING}
//                   onFinishedPlaying={this.handleSongFinishedPlaying}
//                   onPlaying={this.handleSongPlaying}
//                   volume={this.state.volume}
//                 />}
//                 {this.state.blobURL && this.state.recordingSoundStatus && <Sound
//                   url={this.state.blobURL}
//                   playStatus={Sound.status.PLAYING}
//                   onPlaying={this.handleRecordPlaying}

//                   onFinishedPlaying={this.playRecording}
//                 />}
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col xs={12} className="p-0">
//                 <div className="bottomBtns shadow-none card-wrapper">                                
//                   {!this.state.startFlag && <button className="prev-next-btn" disabled={!this.state.nextFlag} onClick={this.nextButton} size="xs">NEXT</button>}
//                   {this.state.startFlag && <button className="prev-next-btn" onClick={this.props.showTest} size="xs">Next</button>}
//                 </div>
//             </Col>
//           </Row>
//         </div>*/}
//       </>
//     );
//   }
// }

// export default ResourceCheck;

import React, { useState, useEffect, useRef } from "react";
// import {
//   Button,
//   Card,
//   CardHeader,
//   Card.Body,
//   CardTitle,
//   CardFooter,
//   Label,
//   FormGroup,
//   Form,
//   Alert,
//   Input,
  
//   InputGroupText,
//   InputGroup,
//   Container,
//   Col,
//   Row,
//   Progress,
//   Modal,
//   ModalHeader,
//   Modal.Body,
//   Modal.Footer
// } from "reactstrap";
import {
  Button,  Card,  Form,  Col,  Row,  ProgressBar,  Modal } from "react-bootstrap";
// import cookie from 'react-cookies';
// import axios from 'axios';
import "components/custom.css";
import currentStatus from "components/current-status.jpg";
import completeStatus from "components/current-status-complete.jpg";
import playingStatus from "components/current-status-playing.jpg";
import completeRecord from "components/current-status-record-complete.jpg";
import currentRecording from "components/current-status-recording.jpg";
import img from "components/a.png";
import API, { base, s3base } from "api.js";
// import IntroTest from "components/Question/Speaking/IntroTest.jsx";
import { store, persistor } from 'store/index';
// import { setSub } from 'action/index.js';
// import NotificationAlert from "react-notification-alert";
// import { Navigate, NavLink } from "react-router-dom";
// import NoMicrophone from "views/NoMicrophone.jsx";
// DEPRECATED: mic-recorder-to-mp3 is outdated and incompatible with Vite - temporarily disabled for future removal
// import MicRecorder from 'mic-recorder-to-mp3';
// import Recorder from 'components/Recorder';
import ReusableRecorder from 'components/Recorder/ReusableRecorder.jsx';
import Sound from 'react-sound';
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import MicWaveform from "components/Question/Speaking/MicWaveform";
// import OpenWithIcon from '@mui/icons-material/OpenWith';
// import NightsStayIcon from '@mui/icons-material/NightsStay';
import stopImage from "assets/images/stop recording.png";
import grayImage from "assets/images/gray circle.png";
import FullScreen from "assets/images/FullScreen.png";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import DarkMode from "assets/images/DarkMode.png";
import HeadsetCheck from "assets/images/HeadphoneNewCheck.png";
import InfoImage from "assets/images/info.png";
import { toggleFullScreen, toggleTheme, isFullScreen, isDarkMode } from "util/helper";

const ResourceCheck = (props) => {
  // DEPRECATED: mic-recorder-to-mp3 is outdated and incompatible with Vite - temporarily disabled for future removal
  // const [Mp3Recorder] = useState(() => new MicRecorder({ bitRate: 128 }));
  const recorderRef = useRef(null);
  const [questionData, setQuestionData] = useState([]);
  const [soundStatus, setSoundStatus] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [volume, setVolume] = useState(100);
  const [soundPer, setSoundPer] = useState(0);
  const [recordPer, setRecordPer] = useState(0);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingSoundStatus, setRecordingSoundStatus] = useState(false);
  const [btnText, setBtnText] = useState('Playback');
  const [mic, setMic] = useState(false);
  const [recordingStartTime, setRecordingStartTime] = useState(null);
  const [recordingInterval, setRecordingInterval] = useState(null);
  const [headphone, setHeadphone] = useState(false);
  const [keyboard, setKeyboard] = useState(false);
  const [testDetail, setTestDetail] = useState(false);
  const [currDetail, setCurrDetail] = useState(false);
  const [sequenceArr, setSequenceArr] = useState([]);
  const [index, setIndex] = useState(0);
  const [nextFlag, setNextFlag] = useState(false);
  const [startFlag, setStartFlag] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [intro, setIntro] = useState(false);
  const [speak_inst, setSpeakInst] = useState(false);
  const [test_intro, setTestIntro] = useState(false);
  const [modal, setModal] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [waveformKey, setWaveformKey] = useState(0);
  const [, forceUpdate] = useState();

  useEffect(() => {
    // Modern way to request microphone permission
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        // console.log('Permission Granted');
        setIsBlocked(false);
        // Stop the stream immediately, we just needed permission
        // stream.getTracks().forEach(track => track.stop());
      })
      .catch((err) => {
        console.log('Permission Denied', err);
        setIsBlocked(true);
      });

    let arr;
    if (props.cat === 1) {
      arr = ['headphone', 'mic'];
      setSequenceArr(arr);
    } else if (props.cat === 2) {
      arr = ['keyboard'];
      setSequenceArr(arr);
    } else if (props.cat === 3) {
      arr = ['keyboard'];
      setSequenceArr(arr);
    } else if (props.cat === 4) {
      arr = ['headphone', 'keyboard'];
      setSequenceArr(arr);
    } else if (props.cat === 5 && props.pending == 1) {
      arr = ['headphone', 'mic', 'keyboard'];
      setSequenceArr(arr);
    } else if (props.cat === 5 && props.pending == 0) {
      // arr = ['headphone', 'mic', 'keyboard', 'test_intro', 'speak_inst', 'testDetail', 'currDetail', 'intro'];
      arr = ['headphone', 'mic', 'keyboard', 'test_intro', 'speak_inst', 'testDetail', 'currDetail'];
      setSequenceArr(arr);
    }

    let flag = false;
    if (arr && arr[0] === 'keyboard') {
      flag = true;
    }

    if (arr && arr[0]) {
      switch (arr[0]) {
        case 'headphone':
          setHeadphone(true);
          break;
        case 'mic':
          setMic(true);
          break;
        case 'keyboard':
          setKeyboard(true);
          break;
        case 'testDetail':
          setTestDetail(true);
          break;
        case 'currDetail':
          setCurrDetail(true);
          break;
        case 'test_intro':
          setTestIntro(true);
          break;
        case 'speak_inst':
          setSpeakInst(true);
          break;
        case 'intro':
          setIntro(true);
          break;
      }
      setNextFlag(flag);
    }
  }, [props.cat, props.pending]);

  const onSound = () => {
    if (!soundStatus) {
      setSoundStatus(true);
    }
  };

  const offSound = () => {
    if (soundStatus) {
      setSoundStatus(false);
      setNextFlag(true);
    }
  };

  const handleSongFinishedPlaying = () => {
    setSoundStatus(false);
    setNextFlag(true);
  };

  const recordingFinishedPlaying = () => {
    setRecordingSoundStatus(false);
    setIsCompleted(true);
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const handleSongPlaying = (obj) => {
    setSoundPer(obj.position * 100 / obj.duration);
  };

  const handleRecordPlaying = (obj) => {
    setRecordPer(obj.position * 100 / obj.duration);
  };

  const updateStateByKey = (key, value) => {
    switch (key) {
      case 'headphone':
        setHeadphone(value);
        break;
      case 'mic':
        setMic(value);
        break;
      case 'keyboard':
        setKeyboard(value);
        break;
      case 'testDetail':
        setTestDetail(value);
        break;
      case 'currDetail':
        setCurrDetail(value);
        break;
      case 'test_intro':
        setTestIntro(value);
        break;
      case 'speak_inst':
        setSpeakInst(value);
        break;
      case 'intro':
        setIntro(value);
        break;
    }
  };

  const nextButton = () => {
    setSoundStatus(false);
    setSoundPer(0);
    if (index < (sequenceArr.length - 1)) {
      let arr = sequenceArr;
      let oldIndex = index;
      let newIndex = index + 1;
      let flag = false;
      let mod = false;
      if ([arr[newIndex]] == 'keyboard' || [arr[newIndex]] == 'testDetail' || [arr[newIndex]] == 'currDetail' || [arr[newIndex]] == 'test_intro' || [arr[newIndex]] == 'speak_inst' || [arr[newIndex]] == 'intro') {
        flag = true;
      }
      updateStateByKey(arr[newIndex], true);
      updateStateByKey(arr[oldIndex], false);
      setIndex(newIndex);
      setNextFlag(flag);
      setModal(mod);
    } else {
      if (sequenceArr[index] == 'intro') {
        setModal(true);
      } else {
        setStartFlag(true);
      }
    }
  };

  const playRecording = () => {
    if (recordingSoundStatus) {
      setRecordingSoundStatus(false);
      setBtnText('Playback');
      setNextFlag(true);
      setIsCompleted(true);
    } else {
      if (blobURL) {
        setRecordingSoundStatus(true);
        setBtnText('Stop Playback');
      }
    }
  };

  const nextStep = () => {
    if (index < (sequenceArr.length - 1)) {
      setNextFlag(true);
    } else {
      setStartFlag(true);
    }
  };

  const startRecording = () => {
    if (isBlocked) {
      alert("Please attach your microphone");
    } else {
      // Reset states for new recording
      setRecordPer(0);
      setBlobURL('');
      setBtnText('Playback');
      setRecordingSoundStatus(false);
      setIsCompleted(false);
      setWaveformKey(prev => prev + 1); // Force remount waveform
      
      if (recorderRef.current) {
        recorderRef.current.startRecording();
      }
    }
  };

  const toggleYes = () => {
    setModal(false);
    setStartFlag(true);
    props.showTest();
  };

  const toggle = () => {
    setModal(false);
  };

  const stopRecording = () => {
    if (!isBlocked && recorderRef.current) {
      recorderRef.current.stopRecording();
    }
  };

  const handleRecordingComplete = (data) => {
    setBlobURL(data.url);
    setRecordPer(100);
    setNextFlag(true);
    console.log('Recording completed:', data);
  };

  const handleRecordingStart = () => {
    setIsRecording(true);
    
    // Start progress tracking for visual feedback
    const maxRecordingTime = 30000; // 30 seconds
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min((elapsed / maxRecordingTime) * 100, 100);
      setRecordPer(progress);
      
      if (progress >= 100) {
        clearInterval(interval);
      }
    }, 100);
    
    setRecordingInterval(interval);
  };

  const handleRecordingStop = () => {
    setIsRecording(false);
    
    // Clear progress tracking interval
    if (recordingInterval) {
      clearInterval(recordingInterval);
      setRecordingInterval(null);
    }
    
    // Stop waveform animation by setting progress to 100
    setRecordPer(100);
  };

  // Cleanup interval on unmount
  useEffect(() => {
    return () => {
      if (recordingInterval) {
        clearInterval(recordingInterval);
      }
    };
  }, [recordingInterval]);

  // Playback does not update waveform progress to keep it static

  // Auto-start logic
  useEffect(() => {
    if (sequenceArr[index] != 'intro' && index == (sequenceArr.length - 1) && !startFlag) {
      setStartFlag(true);
    }
  }, [sequenceArr, index, startFlag]);


  return (
    <>
      {modal && (
        // <Modal isOpen={modal} size="sm">
        //   <Modal.Body>
        //     <div>Do you want to go to next Question?</div>
        //   </Modal.Body>
        //   <Modal.Footer>
        //     <Button
        //       color="secondary"
        //       className="modalCloseBtn"
        //       onClick={toggleYes}
        //     >
        //       Yes
        //     </Button>
        //     <Button
        //       color="secondary"
        //       className="modalCloseBtn"
        //       onClick={toggle}
        //     >
        //       No
        //     </Button>
        //   </Modal.Footer>
        // </Modal>
        <Modal
          show={modal}
          size="md"
          centered
          contentClassName="mock-container"
        >
          <Modal.Header
            style={{ padding: "0px" }}
            className="mock-popup-header"
          >
            <div className="d-flex justify-content-end align-items-center p-2">
              <button onClick={toggle} className="modal-close-btn">
                ×
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex gap-2 align-items-center mock-resource-text">
              <div className="d-flex justify-content-center align-items-center">
                <img
                  src={InfoImage}
                  alt="Information"
                  style={{
                    height: "40px",
                    width: "30px",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </div>{" "}
              Do you want to go to next Question?
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              color="secondary"
              className="mock-test-modal-button"
              onClick={toggleYes}
            >
              Yes
            </Button>
            <Button
              color="secondary"
              className="mock-test-modal-button"
              onClick={toggle}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <div
        className="content questionsArea deviceTestPage old-design m-0 p-0"
        id="test-card"
      >
        <Row className="mock-header-gap header-width">
          <Col xs={12} className="p-0">
            <div className="border-top-0 bg-transparent">
              <div className="p-0">
                <div
                  className="d-flex align-items-end flex-column gap-1 rounded-2 mock-header-gap"
                  // style={{ backgroundColor: "white" }}
                >
                  <div
                    className="d-flex justify-content-between align-items-center w-100 mock-header-bg"
                    style={{
                      height: "40px",
                    }}
                  >
                    <div style={{ width: "fit-content", padding: "20px" }}>
                      <h4 className="m-0">Mock Test</h4>
                    </div>
                  </div>

                  <div
                    className="d-flex justify-content-end align-items-center px-4 w-100"
                    style={{
                      backgroundColor: "#0081A4",
                      minHeight: "40px",
                    }}
                  >
                    <div className="d-flex justify-content-end gap-3">
                      {/* <OpenWithIcon sx={{ color: "white" }} />
                      <NightsStayIcon sx={{ color: "white" }} /> */}
                      <img
                        src={isFullScreen() ? ExitFullScreen : FullScreen}
                        onClick={() => {
                          toggleFullScreen();
                          setTimeout(() => {
                            forceUpdate({});
                          }, 100);
                        }}
                        alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
                        className="toggle-icons"
                      />
                      <img
                        src={isDarkMode() ? LightMode : DarkMode}
                        onClick={() => {
                          toggleTheme();
                          forceUpdate({});
                        }}
                        alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
                        className="toggle-icons"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} style={{ width: "100vw" }} className="p-0">
            <Card className="border-0 mock-container" id="mock-test">
              <Card.Body>
                {headphone && (
                  <div className="col-xs-12 successContent justify-content-start">
                    <div className="row">
                      <div className="col-sm-8 mock-resource-text">
                        <h4 className="mt-0">Headset check</h4>
                        <h6>
                          This is an opportunity to check that your headset is
                          working correctly
                        </h6>
                        <ol>
                          <li>
                            Put your headset on and adjust it so that if it's
                            comfortably over your ears
                          </li>
                          <li>
                            When you are ready. cilck on the play button. You
                            hear a short recording
                          </li>
                          <li>
                            If you do not hear anything in your headphones while
                            the status reads Playing. Raise your hard to get the
                            alteration of the Test Administator
                          </li>
                          <li>
                            During the test you will not have Play and Stop
                            buttons. The audio recording will start playing
                            automatically
                          </li>
                          <li>
                            Please do not remove your headset. You should wear
                            it throughtout the test
                          </li>
                        </ol>
                        {/* <div className="currentStatus">
                          <p>Status: Click Play to begin<br></br>Volume</p>
                          <Input placeholder="Volume" type="range" min="0" defaultValue={volume} step="1" onInput={(e) => changeRange(e)} max="100" />
                          <br></br>
                          <Progress color="info" value={soundPer} />
                          <div className='stop-btn'>
                            <Button color="success" disabled={soundStatus} onClick={onSound} className="p-5px" size="xs">Play</Button>
                            <Button color="success" disabled={!soundStatus} onClick={offSound} className="p-5px" size="xs">Stop</Button>
                          </div>
                        </div> */}
                        <div
                          className="currentStatus d-flex justify-content-center align-items-center p-0  audio-player-section"
                          // style={{ background: "#44bae0", maxWidth: "380px" }}
                        >
                          <div className="w-100 text-white p-4">
                            <div className="d-flex justify-content-center align-items-center w-100 gap-2">
                              {soundStatus ? (
                                <button
                                  className="bg-transparent text-white border-0"
                                  onClick={offSound}
                                >
                                  <i
                                    className="fa fa-stop"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              ) : (
                                <button
                                  className="bg-transparent text-white border-0"
                                  onClick={onSound}
                                >
                                  <i
                                    className="fa fa-play"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              )}
                              <div className="flex-grow-1 mt-4">
                                {/* <Progress
                                  style={{
                                    backgroundColor: "#e9ecef",
                                    height: "15px",
                                  }}
                                  barStyle={{ backgroundColor: "#4493e0" }}
                                  value={soundPer}
                                /> */}
                                <ProgressBar
                                  now={soundPer}
                                  style={{
                                    backgroundColor: "#e9ecef",
                                    height: "15px",
                                  }}
                                  variant="primary"
                                />
                                <p style={{ fontSize: "11px" }}>
                                  Click the play button to start
                                </p>
                              </div>
                            </div>
                            <br></br>
                            <div className="w-100 d-flex justify-content-center align-items-center">
                              <div className="d-flex justify-content-center gap-3  align-items-center w-50">
                                <i
                                  className="fa fa-volume-up"
                                  aria-hidden="true"
                                ></i>
                                {/* <Input
                                  placeholder="Volume"
                                  type="range"
                                  min="0"
                                  defaultValue={volume}
                                  step="1"
                                  onInput={(e) => changeRange(e)}
                                  max="100"
                                /> */}
                                <Form.Range
                                  min={0}
                                  max={100}
                                  step={1}
                                  defaultValue={volume}
                                  onChange={changeRange}
                                  aria-label="Volume"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="testingImgOuter">
                          <img src={HeadsetCheck} alt="headset" />
                        </div>
                      </div>
                    </div>
                    <div className="note w-100 d-none">
                      <ul>
                        <li>
                          During the test you will not have Play and Stop
                          buttons. The audio recording will start playing
                          automatically
                        </li>
                        <li>
                          Please do not remove your headset. You should wear it
                          throughtout the test
                        </li>
                      </ul>
                    </div>
                  </div>
                )}

                {speak_inst && (
                  <div className="col-xs-12 successContent">
                    <div className="row w-100">
                      <div className="col-lg-12 mock-resource-text">
                        <h4 className="mt-0">Speaking Instructions</h4>
                        <h6>
                          Some questions require you to first listen to an audio
                          clip and then record your answer by speaking clearly
                          into the microphone.
                        </h6>
                        <div className="row speakingStatus mb-5 mt-4">
                          <div className="col-sm-4">
                            <p>
                              <b>Listening: </b>The Current Status shows how
                              long you have until the audio clip starts.
                            </p>
                            <img src={currentStatus} />
                          </div>
                          <div className="col-sm-6 pl-5">
                            <p>
                              A blue bar shows the progress of the audio clip.
                              When it reaches the right hand side the audio,
                              clip will stop playing.
                            </p>
                            <div className="row doubleImges">
                              <div className="col-sm-6">
                                <img src={completeStatus} />
                              </div>
                              <div className="col-sm-6">
                                <img src={playingStatus} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row speakingStatus">
                          <div className="col-sm-4">
                            <p>
                              <b>Speaking: </b>The Current Status shows how long
                              you have until the microphone opens. Start
                              speaking when the status changes to recording.
                            </p>
                            <img src={currentStatus} />
                          </div>
                          <div className="col-sm-6 pl-5">
                            <p>
                              You must finish before the progress bar reaches
                              the right hand side. If you remain silent for
                              longer than 3 seconds, the recording will stop.
                              You will not be able to re-record.
                            </p>
                            <div className="row doubleImges">
                              <div className="col-sm-6">
                                <img src={completeRecord} />
                              </div>
                              <div className="col-sm-6">
                                <img src={currentRecording} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {test_intro && (
                  <div className="col-xs-12 successContent">
                    <div className="row w-100">
                      <div className="col-lg-12 mock-resource-text">
                        <h4 className="mt-0">Test Introduction</h4>
                        <h6>
                          This test measures the Reading, Writing, Listening and
                          Speaking skills in English that you will need in an
                          academic setting.
                        </h6>
                        <ol>
                          <li>
                            The test is divided into 3 parts. Each part may
                            contain a number of sections. The sections are
                            individually timed. The timer will be shown in the
                            top right corner of your screen. The number of items
                            in the section will also be displayed.
                            <div className="timeBlock">
                              <div className="timeBlockInr text-right">
                                <p>
                                  <i
                                    className="fa fa-clock-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Time Remaining : 00:32:56
                                </p>
                                <p>Item 22 of 39</p>
                              </div>
                            </div>
                          </li>
                          <li>
                            At the beginning of each part you will receive
                            instructions. These will provide details on what to
                            expect in that part of the test.
                          </li>
                          <li>
                            By clicking on the Next (N) button at the bottom of
                            each screen you confirm your answer and move to the
                            next question. If you click on Next (N) you will not
                            be able to return to the previous question. You will
                            not be able to revisit any question at the end of
                            the test.
                          </li>
                          {props.data.break === 0 ? (
                            <li>
                              You will be offered a break of up to 10 minutes
                              before Listening part. The break is optional.
                            </li>
                          ) : (
                            ""
                          )}
                          <li>
                            This test makes use of different varieties of
                            English, for example, British, American, Australian.
                            You can answer in the standard English variety of
                            your choice.
                          </li>
                          <li>
                            During the test, do not click on any browser buttons
                            (front, back, or reload). If you want to leave in
                            between any sections, just use Save & Exit button.
                            And if you want to leave after finshing a section,
                            just use Save and Exit button.
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                )}

                {mic && (
                  <div className="col-xs-12 successContent justify-content-start">
                    <div className="row w-100">
                      <div className="col-12 col-md-8 mock-resource-text">
                        <h4 className="mt-0">Microphone Check</h4>
                        <h6>
                          This is an opportunity to check that your microphone
                          is working correctly
                        </h6>
                        <ol>
                          <li>
                            Make sure your headset is on and the microphone is
                            in the downward position near your mouth.
                          </li>
                          <li>
                            When you are ready, click on the Record button and
                            say "Testing, testing, one, two, three" into the
                            microphone
                          </li>
                          <li>
                            After you have spoken, cilck on the Stop button.
                            Your recording is now complete
                          </li>
                          <li>
                            Now click on the Playback button. You should clearly
                            hear yourself speaking
                          </li>
                          <li>
                            If you can not hear your voice clearly. please raise
                            your hand to get the atteration of the Test
                            Administrator
                          </li>
                          <li>
                            During the test, you will not have Record, Playback,
                            and Stop buttons. The voice recording will start
                            automatically.
                          </li>
                        </ol>
                        {/* <div className="currentStatus">
                          <p>Status: Click record to begin</p>
                          <Progress color="info" value={recordPer} />

                          <div className='stop-btn'>
                            <Button color="success" disabled={isRecording} className="p-5px" onClick={startRecording} size="xs">Record</Button>
                            <Button color="success" onClick={playRecording} className="p-5px" size="xs">{btnText}</Button>
                            <Button color="success" disabled={!isRecording} onClick={stopRecording} className="p-5px" size="xs">Stop</Button>
                          </div>
                          {isRecording &&
                            <div>Recording is started, please click on stop button for stop recording</div>
                          }
                        </div> */}
                        {/* ReusableRecorder Component - Modern recording solution */}
                        <ReusableRecorder
                          ref={recorderRef}
                          onRecordingComplete={handleRecordingComplete}
                          onRecordingStart={handleRecordingStart}
                          onRecordingStop={handleRecordingStop}
                          maxDuration={30000}
                          enableSpeechRecognition={true}
                          fileName="microphone-test.mp3"
                        />

                        {/* Recording UI Controls */}
                        <div
                          className="d-flex flex-column flex-md-row justify-content-center justify-content-md-start gap-3"
                          style={{ minHeight: "60px" }}
                        >
                          {!isRecording && recordPer > 0 && (
                            <Button
                              color="success"
                              onClick={playRecording}
                              className="custom-btn-design mock-bottom-btn border-0"
                              size="xs"
                            >
                              {btnText}
                            </Button>
                          )}
                          {isRecording ? (
                            <Button
                              color="success"
                              onClick={stopRecording}
                              className="custom-btn-design mock-bottom-btn border-0"
                              size="xs"
                            >
                              Stop
                            </Button>
                          ) : (
                            <Button
                              color="success"
                              className="custom-btn-design mock-bottom-btn border-0"
                              onClick={startRecording}
                              size="xs"
                            >
                              Record
                            </Button>
                          )}
                          {isRecording ? (
                            <img
                              src={stopImage}
                              alt="Stop Recording"
                              style={{
                                height: "65px",
                                width: "65px",
                                objectFit: "contain",
                                display: "block",
                              }}
                            />
                          ) : (
                            <div className="d-flex justify-content-start justify-content-lg-center align-items-center">
                              <img
                                src={grayImage}
                                alt="Not Recording"
                                style={{
                                  height: "65px",
                                  width: "65px",
                                  objectFit: "contain",
                                  display: "block",
                                }}
                              />
                              <p
                                className="text-center p-0 m-0"
                                style={{ fontSize: "20px" }}
                              >
                                Ready
                              </p>
                            </div>
                          )}

                          <div
                            className="d-flex align-items-center flex-grow-1 mb-4"
                            style={{ height: "40px" }}
                          >
                            <div style={{ maxWidth: "300px", width: "100%" }}>
                              <MicWaveform
                                key={waveformKey}
                                progressValue={recordPer}
                                mockColor="#0081A4"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="note d-none">
                          <ul>
                            <li>
                              During the test, you will not have Record,
                              Playback, and Stop buttons. The voice recording
                              will start automatically.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="testingImgOuter">
                          <img src={HeadsetCheck} alt="headset" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {keyboard && !headphone && (
                  <div className="col-xs-12 successContent justify-content-start">
                    <div className="col-lg-12 keyboard-check mock-resource-text">
                      <h4 className="mt-0">Keyboard Check</h4>
                      <h6>
                        This is an opportunity to check that you have the
                        correct keyboard.
                      </h6>
                      <div className="col-xs-12">
                        <ol>
                          <li>
                            Look at the top row of letters on the keyboard.
                          </li>
                          <li>
                            The letters should appear in this order Q W E R T Y.
                          </li>
                          <li>
                            If you do not have a QWERTY keyboard, raise your
                            hand to get the attention of the Test Administrator
                          </li>
                        </ol>
                        <div className="keyboardImg">
                          <img src={img} alt="keyboard" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {testDetail && (
                  <div className="col-xs-12 successContent">
                    <div className="col-lg-12 mock-resource-text">
                      <h4 className="mt-0">
                        Welcome {store.getState().user.first_name}{" "}
                        {store.getState().user.last_name === "null"
                          ? ""
                          : store.getState().user.last_name}
                      </h4>
                      <div className="col-xs-12">
                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <th>Part</th>
                              <th>Content</th>
                              <th>Time Allowed</th>
                            </tr>
                            <tr>
                              <td>1</td>
                              <td>Speaking & writing</td>
                              <td>{props.data.time[0]} minutes</td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>Reading</td>
                              <td>{props.data.time[1]} minutes</td>
                            </tr>
                            {props.data.break === 0 ? (
                              <tr>
                                <td colSpan={2}>Optional scheduled break</td>
                                <td>10 minutes</td>
                              </tr>
                            ) : (
                              ""
                            )}
                            <tr>
                              <td>3</td>
                              <td>Listening</td>
                              <td>{props.data.time[2]} minutes</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                {/* {intro && <IntroTest />} */}

                {currDetail && (
                  <div className="col-xs-12 successContent">
                    <div className="col-lg-12 mock-resource-text">
                      <h4 className="mt-0">
                        Welcome {store.getState().user.first_name}{" "}
                        {store.getState().user.last_name === "null"
                          ? ""
                          : store.getState().user.last_name}
                      </h4>
                      <div className="col-xs-12">
                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <th>Section</th>
                              <th>No of Question</th>
                              <th>Time Allowed</th>
                            </tr>
                            <tr>
                              <td>Speaking & writing</td>
                              <td>{props.data.full[0].length}</td>
                              <td>{props.data.time[0]} minutes</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                {soundStatus && (
                  <Sound
                    url={s3base + "/ptedata/ptemedia/AUD (2)_1539694341.mp3"}
                    playStatus={Sound.status.PLAYING}
                    onFinishedPlaying={handleSongFinishedPlaying}
                    onPlaying={handleSongPlaying}
                    volume={volume}
                    onError={(err) => {
                      if (err.name !== "AbortError") console.error(err);
                    }}
                  />
                )}

                {blobURL && recordingSoundStatus && (
                  <Sound
                    url={blobURL}
                    playStatus={Sound.status.PLAYING}
                    onPlaying={handleRecordPlaying}
                    onFinishedPlaying={recordingFinishedPlaying}
                  />
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12}>
            <div className="bottom-0 bottomBtns d-flex justify-content-center m-0 p-0 position-fixed w-101 mock-header-gap">
              <Row className="gap-1 align-items-center w-100 m-0">
                <Col className="bottom-btn-color mock-bottom-btn-toggle flex-grow-1"></Col>
                <Col
                  xs="auto"
                  className="d-flex justify-content-center align-items-center bottom-btn-color checkResourceButtons mock-bottom-btn-toggle"
                  style={{ minWidth: "20%" }}
                >
                  {!startFlag && (
                    <Button
                      color="primary"
                      disabled={!nextFlag}
                      onClick={nextButton}
                      size="xs"
                      className="mock-btn bottomBtnFont mock-bottom-btn"
                    >
                      NEXT
                    </Button>
                  )}
                  {startFlag && (
                    <Button
                      color="primary"
                      disabled={mic && !isCompleted}
                      onClick={props.showTest}
                      size="xs"
                      className="mock-btn bottomBtnFont mock-bottom-btn"
                    >
                      Next
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ResourceCheck;
